class PageDrone {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
    if ($('.js-page-drone-swiper').length > 0) {
      this.droneSwiper();
    }
  }

  event() {

  }

  droneSwiper() {
    const swiperEle = '.js-page-drone-swiper';
    new Swiper(swiperEle, {
      loop: true,
      speed: 3000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 4000
      }
    })
  }

}

